var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "video-player-container",
    style: _vm.computedStyle
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.doStart,
      expression: "!doStart"
    }],
    staticClass: "video-preview",
    style: _vm.computedStyle,
    on: {
      "click": function ($event) {
        _vm.canPlay ? (_vm.doStart = true, _vm.$nextTick(_vm.handlePlay)) : '';
      }
    }
  }, [_vm.source.video_preview ? _c('el-image', {
    style: _vm.computedStyle,
    attrs: {
      "src": _vm.source.video_preview,
      "fit": "contain",
      "lazy": _vm.lazy
    }
  }) : _vm._e(), _c('span', {
    staticClass: "joinmc mc-a-ziyuan578ldpi"
  })], 1), _c('video', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.doStart,
      expression: "doStart"
    }],
    ref: "videoPlayer",
    style: _vm.computedStyle,
    attrs: {
      "src": _vm.videoSrc,
      "controls": _vm.controls,
      "preload": _vm.videoPreload,
      "autoplay": _vm.doStart
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("common.Video-Not-Supported")) + " ")])]);
};
var staticRenderFns = [];
export { render, staticRenderFns };